class ShoppingCartItem {

    constructor(isPreferredMember, resource, selectedOption, locations) {
        this.resource = resource;
        this.isPreferredMember = isPreferredMember;
        this.selectedOption = selectedOption;
        this.locations = locations;
        this.autoRenew = false;
        if (resource) {
            this.total = this.getTotal();
        }
    }

    getTotal() {
        if (this.isPreferredMember) {
            return this.getMemberTotal();
        }
        return this.getNonMemberTotal();
    }

    getMemberTotal() {
        let memberPrice = this.resource.pricing[this.selectedOption].member_price;
        if (this.resource.per_location) {
            return memberPrice * this.locations.length
        }
        return memberPrice;
    }

    getNonMemberTotal() {
        let price = this.resource.pricing[this.selectedOption].price;
        if (this.resource.per_location) {
            return price * this.locations.length
        }
        return price;
    }

}

export default ShoppingCartItem;


// WEBPACK FOOTER //
// ./src/models/ShoppingCartItem.js